import Stack from '@mui/material/Stack';

import styled from 'shared/utils/styled';

export const Container = styled(Stack)(({ theme, onClick }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: 15,
  background: '#fff',
  boxShadow: '0px 3px 9px rgba(0, 0, 0, 0.11)',
  transition: 'all .15s linear',
  [theme.breakpoints.down('xs')]: {
    padding: '10px 5px',
  },
  ...(!!onClick && {
    '&:hover': {
      background: 'rgb(243, 246, 249)',
    },
    cursor: 'pointer',
  }),
}));

export const Text = styled('span')(({ theme }) => ({
  fontSize: 14,
  color: '#224060',
  [theme.breakpoints.down('xs')]: {
    fontSize: 13,
  },
}));

export const Subject = styled(Text)(() => ({
  flex: 1,
  hyphens: 'auto',
  wordBreak: 'break-word',
}));
